module.exports = __webpack_public_path__ + "img/logo_nightlife.5d1267ba.svg";